import * as yup from 'yup';
import { useTranslations } from 'hooks/useTranslations';

const useAddDecisionFormSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    decision: yup.string().required(t('general.field.validation.required')),
    reasonUniqueIds: yup
      .array()
      .of(yup.string().required())
      .min(1, t('general.field.validation.required'))
      .required(t('general.field.validation.required')),
    comment: yup
      .string()
      .required(t('general.field.validation.required'))
      .max(1000, t('general.field.validation.maxCharacters').replace('{0}', '1000'))
      .trim(),
  });
  return { schema };
};

export default useAddDecisionFormSchema;
